import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

const API_URL = process.env.API_URL

export default {
  query (params) {
    return Vue.http.get(`${API_URL}clients`, {params: params})
  },
  get (id) {
    return Vue.http.get(`${API_URL}clients/${id}`)
  },
  create (data) {
    return Vue.http.post(`${API_URL}clients`, data)
  },
  delete (id) {
    return Vue.http.delete(`${API_URL}clients/${id}`)
  },
  update (id, data) {
    return Vue.http.patch(`${API_URL}clients/${id}`, data)
  },
  checkCnpjExists (cnpj) {
    return Vue.http.post(`${API_URL}clients/cnpj/`, {cnpj: cnpj})
  }
}



// WEBPACK FOOTER //
// ./src/services/client.js